<template>
<v-layout>
  <v-flex>
  <v-tabs
      v-model="active"
    >
      <v-tab><h6>Contacts</h6></v-tab>
      <v-tab v-if="showSSO"><h6>Single Sign-On</h6></v-tab>
      <v-tab-item>
        <org-contacts></org-contacts>
      </v-tab-item>
      <v-tab-item>
        <sso></sso>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</v-layout>
</template>

<script>
import OrgContacts from './OrgContacts.vue'
import SingleSignOn from './SingleSignon.vue'
export default {
  components: {
    'org-contacts': OrgContacts,
    'sso': SingleSignOn
  },
  data() {
    return {
      active: null,
      showSSO: (window.Config.authMode === 'v2'), // from index.html in the UI Container
    }
  },
  watch: {
    "$route.params.tab"(value) {
      console.log(this.$route.params.tab)
      if (this.$route.params.tab) {
          switch(this.$route.params.tab) {
              default: this.active = 0; break;
          }
      }
    }
  },
  created() {
      if (this.$route.params.tab) {
          switch(this.$route.params.tab) {
              default: this.active = 0; break;
          }
      }
  }
}
</script>